<template>
	<div class="container">
		<div class="card">
			<h2 class="card-title text-center pt-2"> Vormelden / Vorversand verbieten </h2>
			<div class="card-body">
				<b-form-select v-model="selectedOperation" :options="operationOptions" class="mb-2"></b-form-select>
				<b-input-group class="mb-2" v-if="selectedOperation === 'preDelivery'">
					<b-form-input id="selectedDate" v-model="deliveryTimeInput" type="text"
												placeholder="H:m:s D-M-Y"></b-form-input>
					<b-input-group-append>
						<b-form-datepicker v-model="selectedDate" button-only right start-weekday="1"
															 aria-controls="selectedDate"></b-form-datepicker>
						<b-form-timepicker locale="de" v-model="selectedTime"></b-form-timepicker>
					</b-input-group-append>
				</b-input-group>
				<b-form-textarea @paste="TextAreaNextLine" class="mb-2" v-model="customerorderIdsTextArea" placeholder="CustomerOrderIds eingeben"
												 style="min-height: 300px"></b-form-textarea>
				<div class="text-right mb-2">
					<b-btn variant="secondary" @click="sendData()">absenden</b-btn>
				</div>
				<div v-if="statuses.length > 0" class="text-center">
					<h4>Ergebnis</h4>
					<b-table-simple>
						<b-thead>
							<b-tr>
								<b-th>OrderId</b-th>
								<b-th>Status</b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr v-for="status in statuses" :key="status.id">
								<b-td>
									{{ status.id }}
								</b-td>
								<b-td>
									{{ setStatusText(status.result) }}
								</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</div>
			</div>
		</div>
		<modal-error-component v-model="modalError"></modal-error-component>
	</div>
</template>
<script>
import ModalErrorComponent from "./ModalErrorComponent.vue";

export default {
	components: {ModalErrorComponent},
	data() {
		return {
			selectedOperation: null,
			selectedDate: moment().format("DD.MM.YYYY"),
			selectedTime: moment().format("HH:mm"),
			operationOptions: [
				{value: null, text: "Vorversandart auswählen", disabled: true},
				{value: "preDelivery", text: "Vormelden"},
				{value: "preDeliveryBan", text: "Vorversand verbieten"},
			],
			customerorderIdsTextArea: "",
			statuses: [],
			deliveryTimeInput: moment().format("DD.MM.YYYY HH:mm"),
			modalError: {
				show: false,
				title: "",
				message: ""
			}
		}
	},
	watch: {
		selectedDate(newVal) {
			this.deliveryTimeInput = moment(newVal, 'YYYY-MM-DD').format('DD.MM.YYYY') + ' ' + this.selectedTime;
		},
		selectedTime(newVal) {
			this.deliveryTimeInput = this.selectedDate + ' ' + moment(newVal, 'HH:mm').format('HH:mm');
		}
	},
	methods: {
		sendData() {
			if (!this.selectedOperation) return alert("Bitte Vorversandart auswählen");
			this.statuses = [];

			const request = {
				deliveryTime: moment(this.deliveryTimeInput, "DD.MM.YYYY HH:mm").format('DD-MM-YYYY HH:mm:ss'),
				customerOrderIds: this.customerorderIdsTextArea.split('\n').filter(id => id.trim() !== '')
			}
			const route = this.selectedOperation === "preDelivery" ? "/predelivery" : "/predeliveryban";
			axios.post(route, request)
					.then(res => {
						console.log(res);
						this.statuses = res.data;
					})
					.catch(err => {
						console.log(err);
						this.modalError = {
							show: true,
							title: "Vorversand",
							message: err.response?.data?.error || err.response?.data?.message || "Ein Fehler ist aufgetreten"
						}
					})
		},

		TextAreaNextLine(event) {
			const textArea = event.target;
			let cursorPosition = textArea.selectionStart;
			let value = textArea.value;

			// Check if the cursor is at the end + textfield not empty + last symbol not newLine character
			if (cursorPosition === value.length && this.customerorderIdsTextArea != "" &&
					this.customerorderIdsTextArea.slice(-1) != '\n') {

				// Append a newline character and set the new textArea value
				textArea.value = `${value}\n`;
				this.customerorderIdsTextArea = textArea.value;

				// Update the cursor position to the end of the new line
				Vue.nextTick(() => {
					textArea.selectionStart = cursorPosition + 1;
					textArea.selectionEnd = cursorPosition + 1;
				});
			} else {
				this.customerorderIdsTextArea = value;
			}
		},
		setStatusText(id) {
			if(this.selectedOperation === "preDelivery") {
				switch (id) {
					case 0:
            return "Vorversand OK";
					case 1:
            return "Bestellung nicht gefunden";
					case 2:
						return "Vorversand OK - Kein Charge wenn shipped";
					case 3:
						return "schon versendet/vorgemeldet";
					default:
						return "Unbekannter Fehler";
				}
			} else {
				return id;
			}
		}
	},
}
</script>
